let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("iw9Yr"), load("8xJ7I"), load("aVx5L"), load("abgjf"), load("6aruy")]).then(() => parcelRequire('9VKkC'));